module.exports = {
    //HOST: 'http://localhost:5001',
    HOST: 'https://examples.thepubverse.com/api',
    APIKEY: 'a36d7aac61e359e2d828bedbfbc51aa910be1e5d119648ad53f8a3213d7b5bbe'
}